import React from 'react'
import clsx from 'clsx'
import Container from '@material-ui/core/Container'
import Footer from 'ui/modules/footer'
import CookiesPopover from 'ui/modules/popover/cookiesPopover'
import useStyles from './styles'

function useViewportHeightCustomProperty() {
  React.useLayoutEffect(() => {
    const handleResize = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
    handleResize()
    window.addEventListener('resize', handleResize, { passive: true })
    return () => window.removeEventListener('resize', handleResize)
  }, [])
}

const Main = props => {
  const { open, isLogged, isLanding, children } = props
  useViewportHeightCustomProperty()
  const classes = useStyles()
  return (
    <main
      className={clsx(
        classes.content,
        open && classes.contentExpanded,
        !isLogged && classes.contentLanding,
      )}
    >
      <>
        <div className={classes.appBarSpacer} />
        <Container
          maxWidth={false}
          disableGutters={isLanding}
          className={clsx(!isLanding && classes.mainContainer)}
        >
          {children}
        </Container>
      </>
      <Footer />
      <CookiesPopover open={false} />
    </main>
  )
}
export default Main
